
import { isEmptyObject } from '../../helper/utils/isEmptyObject';
import { getItemsNoVoid } from './menuItem';

export function getPriceModifierItem(modifier = {}, salesOrderData) {
    if (isEmptyObject(modifier)) {
        return 0;
    }

    const price = parseFloat((modifier[`Price${salesOrderData['SalesTypeCode']}`] || '0').toString());
    const qty = parseFloat(modifier['qty'] || '0');

    return price * qty;
}

export function getPriceModifier(menu = {}, salesOrderData = {}) {
    if (!isEmptyObject(menu)) {
        const modifiers = (menu['modifier'] || []).filter((modifier) => modifier != null) || [];

        if (modifiers.length > 0) {
            const prices = modifiers?.map((modifier) => parseFloat((modifier[`Price${salesOrderData['SalesTypeCode']}`] || '0').toString()) * parseFloat((modifier['qty'] || '0').toString())) || [];

            return parseFloat(prices.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0).toString());
        }
    }

    return 0;
}

export function getPriceModifierDiscount(menu = {}) {
    if (!isEmptyObject(menu)) {
        const modifiers = (menu['modifier'] || []).filter((modifier) => modifier != null) || [];

        if (modifiers.length > 0) {
            const prices = getItemsNoVoid(modifiers)?.map((modifier) => parseFloat(modifier['discValuex'] || '0'.toString())) || [];

            return parseFloat(prices.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0).toString());
        }
    }

    return 0;
}

export function getPriceModifierTax(menu = {}) {
    if (!isEmptyObject(menu)) {
        const modifiers = (menu['modifier'] || []).filter((modifier) => modifier != null) || [];

        if (modifiers.length > 0) {
            const prices = getItemsNoVoid(modifiers)?.map((modifier) => parseFloat((modifier['taxVal'] || '0').toString())) || [];

            return parseFloat(prices.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0).toString());
        }
    }

    return 0;
}

export function getPriceModifierService(menu = {}) {
    if (isEmptyObject(menu)) {
        const modifiers = (menu['modifier'] || []).filter((modifier) => modifier != null) || [];

        if (modifiers.length > 0) {
            const prices = getItemsNoVoid(modifiers)?.map((modifier) => parseFloat((modifier['servVal'] || '0').toString())) || [];

            return parseFloat(prices.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0).toString());
        }
    }

    return 0;
}

export function getGrandTotalModifierItem(modifier = {}, salesOrderData = {}) {
    if (isEmptyObject(modifier)) {
        return 0;
    }

    return getPriceModifierItem(modifier, salesOrderData) - parseFloat(modifier['discValuex'] || '0'.toString());
}
